/**
 * Русское согласование числа и единицы номинала для автоназвания: «1 рубль», «2 рубля»,
 * «10 рублей», «1,5 рубля». Словарь — единицы из стартового справочника; неизвестная
 * единица остаётся в исходной форме.
 */
const FORMS = {
    рубль: ['рубля', 'рублей'],
    копейка: ['копейки', 'копеек'],
    деньга: ['деньги', 'денег'],
    полушка: ['полушки', 'полушек'],
    гривна: ['гривны', 'гривен'],
    доллар: ['доллара', 'долларов'],
    цент: ['цента', 'центов'],
    евро: ['евро', 'евро'],
    евроцент: ['евроцента', 'евроцентов'],
    фунт: ['фунта', 'фунтов'],
    пенни: ['пенни', 'пенни'],
    шиллинг: ['шиллинга', 'шиллингов'],
    франк: ['франка', 'франков'],
    сантим: ['сантима', 'сантимов'],
    марка: ['марки', 'марок'],
    пфенниг: ['пфеннига', 'пфеннигов'],
    крона: ['кроны', 'крон'],
    эре: ['эре', 'эре'],
    злотый: ['злотых', 'злотых'],
    грош: ['гроша', 'грошей'],
    лира: ['лиры', 'лир'],
    песо: ['песо', 'песо'],
    динар: ['динара', 'динаров'],
    лев: ['лева', 'левов'],
    форинт: ['форинта', 'форинтов'],
    драхма: ['драхмы', 'драхм'],
    иена: ['иены', 'иен'],
    юань: ['юаня', 'юаней'],
    рупия: ['рупии', 'рупий'],
    тенге: ['тенге', 'тенге'],
};
export function pluralizeUnit(amount, unit) {
    const forms = FORMS[unit.toLowerCase()];
    if (!forms || !Number.isFinite(amount))
        return unit;
    // Дробное число согласуется как «несколько»: «1,5 рубля».
    if (!Number.isInteger(amount))
        return forms[0];
    const n = Math.abs(amount) % 100;
    const last = n % 10;
    if (n >= 11 && n <= 14)
        return forms[1];
    if (last === 1)
        return unit;
    if (last >= 2 && last <= 4)
        return forms[0];
    return forms[1];
}
//# sourceMappingURL=plural.js.map